import { render, staticRenderFns } from "./electronicContactLimit.vue?vue&type=template&id=575fcbc1&scoped=true"
import script from "./electronicContactLimit.vue?vue&type=script&lang=js"
export * from "./electronicContactLimit.vue?vue&type=script&lang=js"
import style0 from "./electronicContactLimit.vue?vue&type=style&index=0&id=575fcbc1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575fcbc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575fcbc1')) {
      api.createRecord('575fcbc1', component.options)
    } else {
      api.reload('575fcbc1', component.options)
    }
    module.hot.accept("./electronicContactLimit.vue?vue&type=template&id=575fcbc1&scoped=true", function () {
      api.rerender('575fcbc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/component/electronicContactLimit.vue"
export default component.exports